<template>
  <v-list-item>
    <v-list-item-avatar tile size="60">
      <v-img v-if="value && value.image && value.image.url" :src="value.image.url" style="border-radius: 4px">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-icon> mdi-gift </v-icon>
          </v-row>
        </template>
      </v-img>
      <v-icon large v-else> mdi-gift </v-icon>
    </v-list-item-avatar>

    <v-list-item-content v-if="value">
      <v-list-item-title style="display: flex" v-if="!value.title">
        {{ $t(`common.PromotionTypeEnum.${value.type}`) }}
      </v-list-item-title>
      <v-list-item-title style="display: flex" v-else>
        <span v-html="value.title"></span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="value.subtitle" v-html="value.subtitle" />
      <v-list-item-subtitle v-if="value.description" v-html="value.description" />
      <v-list-item-subtitle v-if="value.hint" v-html="value.hint" />
    </v-list-item-content>
    <v-list-item-action>
      <span><span v-if="value.hint">*</span> {{ valueString }} </span>
    </v-list-item-action>
  </v-list-item>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { CurrencyUnitEnum } from "@/store/enum/thg/currency-unit.enum";
import { $t } from "@/lib/utility/t";
import { ActivePromotion } from "@/store/models/thg/active-promotion";

@Component({
  components: {},
  filters: {}
})
export default class ThgPromotionListItem extends Vue {
  @Prop()
  value!: ActivePromotion;

  get valueString() {
    if (this.value.currency === CurrencyUnitEnum.CENT) {
      // make 123213 to 1232.13 €
      const value = this.value.value.toString();
      return `${value.slice(0, -2)},${value.slice(-2)} €`;
    }
    if (this.value.currency === CurrencyUnitEnum.TEUR) {
      return `${this.value.value * 1000} €`;
    }
    if (this.value.currency === CurrencyUnitEnum.EUR) {
      return `${this.value.value},00 €`;
    }

    return "N/A";
  }

  get type() {
    return $t(`common.PromotionTypeEnum.${this.value.type}`).toUpperCase();
  }
}
</script>
